module.exports = __webpack_public_path__ + "img/gb818.prt.be92f455.jpg";